var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vc-calendar',{attrs:{"title-position":"right","attributes":_vm.attributes,"is-dark":_vm.dark,"is-expanded":_vm.fill}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }